import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'condenseAddress'
})
export class CondenseAddressPipe implements PipeTransform {
    static SPACE: string = ' ';

	transform(value: any) {
		if (value) {
            let condensedAddress = '';

			if (!this.IsNullOrWhiteSpace(value.name)) {condensedAddress += value.name + CondenseAddressPipe.SPACE} ;
			if (!this.IsNullOrWhiteSpace(value.address1)) {condensedAddress += value.address1 + CondenseAddressPipe.SPACE};
			if (!this.IsNullOrWhiteSpace(value.address2)) {condensedAddress += value.address2 + CondenseAddressPipe.SPACE};
			if (!this.IsNullOrWhiteSpace(value.city)) {condensedAddress += value.city + CondenseAddressPipe.SPACE};
			if (!this.IsNullOrWhiteSpace(value.state)) {condensedAddress += value.state + CondenseAddressPipe.SPACE};
			if (!this.IsNullOrWhiteSpace(value.zip)) {condensedAddress += value.zip};
			if (!this.IsNullOrWhiteSpace(value.plus4)) {condensedAddress += '-' + value.plus4};

			return condensedAddress;
		}
	}

    IsNullOrWhiteSpace(str) {
		return (!str || str.trim() === '');
	}
}
